import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IEntryType, IEntryTypeInitialState } from "./visaentrytypeModel";
import {
  ActiveInactiveEntryType,
  createEntryType,
  deleteEntryType,
  getAllActiveEntryTypes,
  getAllEntryTypes,
  getEntryTypeByID,
  updateEntryType,
} from "./services/visaentrytype.services";

const initialState: IEntryTypeInitialState = {
  loading: false,
  formLoading: false,
  error: "",
  EntryTypeList: [],
  EntryTypeID: null,
  EntryTypeDetail: {
    EntryType: "",
    IsActive: 1,
  },
};

const entrytypeSlice = createSlice({
  name: "visaentrytype",
  initialState,
  reducers: {
    clearEntryTypeDetails: (state) => {
      state.  EntryTypeDetail = initialState.EntryTypeDetail;
    },
    setEntryTypeID: (state, action) => {
      state.EntryTypeID = action.payload;
    },
    clearEntryTypeID: (state) => {
      state.EntryTypeID = initialState.EntryTypeID;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllEntryTypes.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllEntryTypes.fulfilled,
      (state, action: PayloadAction<IEntryType[]>) => {
        state.loading = false;
        state.EntryTypeList = action.payload || [];
      }
    );
    builder.addCase(getAllEntryTypes.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.EntryTypeList = [];
    });
    builder.addCase(createEntryType.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(createEntryType.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(createEntryType.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(updateEntryType.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(updateEntryType.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(updateEntryType.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(deleteEntryType.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteEntryType.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteEntryType.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getEntryTypeByID.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(getEntryTypeByID.fulfilled, (state, action: any) => {
      state.formLoading = false;
      state.EntryTypeDetail = action.payload;
    });
    builder.addCase(getEntryTypeByID.rejected, (state, action) => {
      state.formLoading = false;
      state.EntryTypeDetail = initialState.EntryTypeDetail;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getAllActiveEntryTypes.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllActiveEntryTypes.fulfilled,
      (state, action: PayloadAction<IEntryType[]>) => {
        state.loading = false;
        state.EntryTypeList = action.payload || [];
      }
    );
    builder.addCase(getAllActiveEntryTypes.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.EntryTypeList = [];
    });
    builder.addCase(ActiveInactiveEntryType.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(ActiveInactiveEntryType.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(ActiveInactiveEntryType.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const {
  clearEntryTypeDetails,
  clearEntryTypeID,
  setEntryTypeID,
} = entrytypeSlice.actions;
export default entrytypeSlice.reducer;
